// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const pingClient = createTypedClient();
export const createPingClient = (config) => createTypedClient(config);
